import React from "react";
import styles from "./formCategory.module.css";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";

function ApplicationCategory({ register, errors }) {
  return (
    <div className={styles.category_tab}>
      <Grid container spacing={1}>
  
        <Grid item xs={12} sm={4}>
          <div className={styles.category}>
            <div className={styles.category_heading}>
            <Typography variant="h6">Application Category </Typography>
            <Typography>
                *
            </Typography>
            </div>
           
            <Typography>
              Please select a category of application you wish to make
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} sm={8}>
          <div className={styles.category_form}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <div className={styles.radio_field}>
                  <div className={styles.radio_input_label}>
                    <input
                      type="radio"
                      {...register("category")}
                      value="individual"
                    />
                    <Typography>Individual Application</Typography>
                  </div>
                  {errors?.category && (
                    <Typography style={{ marginTop: 8, color: "red", fontSize: '12px' }}>
                      {errors?.category?.message}
                    </Typography>
                  )}
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.radio_field}>
                  <div className={styles.radio_input_label}>
                    <input
                      type="radio"
                      {...register("category")}
                      value="joint"
                    />
                    <Typography>Joint Application </Typography>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default ApplicationCategory;
